import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";

import { AppState } from "../../store/app.state";
import * as NotificationActions from "../../store/notification/notification.actions";
import { NotificationMessagePayload } from "../../store/notification/notification.actions";
import { Code } from "../../store/notification/notification.state";

/**
 * This service exposes the subset of actions which consumers are allowed to call.
 */
@Injectable({
  providedIn: "root",
})
export class NotificationService {
  constructor(private readonly _store: Store<AppState>) {}

  // Create a single notification message
  createNotificationMessage(
    notificationMessagePayload: NotificationMessagePayload,
  ) {
    this.createNotificationMessages([notificationMessagePayload]);
  }

  // Create multiple notification messages
  createNotificationMessages(
    notificationMessagePayloads: NotificationMessagePayload[],
  ) {
    this._store.dispatch(
      NotificationActions.createNotifications({
        notificationMessagePayloads: notificationMessagePayloads,
      }),
    );
  }

  // Create a notification message, if no other message with the same 'code' already exists
  createNotificationMessageIfNotExist(
    notificationMessagePayload: NotificationMessagePayload,
  ) {
    this._store.dispatch(
      NotificationActions.createNotificationIfNotFound({
        notificationMessagePayload: notificationMessagePayload,
      }),
    );
  }

  // Try to delete all notification message with a given 'code'
  tryDeleteNotificationMessages(code: Code) {
    this._store.dispatch(
      NotificationActions.tryDeleteNotifications({
        code: code,
      }),
    );
  }
}
